// Hardcoded upload thresholds for inspection-report media. Mirrors the backend
// MAX_UPLOAD_BYTES (200 MB). Videos count toward these totals just like photos.
export const SOFT_WARN_BYTES = 50 * 1024 * 1024;
export const HARD_MAX_BYTES = 200 * 1024 * 1024;

/**
 * Sum the byte size of every File across the given groups.
 * Per-system photos are File[][] (spread each into its own group); flat section
 * photos are File[] (pass as a single group).
 */
export function sumMediaBytes(groups: File[][]): number {
  return groups.reduce((total, files) => total + files.reduce((sum, file) => sum + file.size, 0), 0);
}

/** Human-readable megabytes for user messages, e.g. 88080384 -> "84 MB". */
export function formatMb(bytes: number): string {
  return `${Math.round(bytes / (1024 * 1024))} MB`;
}
